export default {
  data() {
    return {
      width: 0,
      height: 0,
    };
  },

  methods: {
    updateSize() {
      this.width = this.$refs.element.clientWidth;
      this.height = this.$refs.element.clientHeight;
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.updateSize();
      this.$emit('resized');
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/sizeMixin.js